/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers').controller('ReportsActiveLogController', reportsActiveLogController)

  reportsActiveLogController.$inject = ['$rootScope', '$http', 'NotificationService', 'ReportsActiveLogService', 'MessageWebhookService']

  function reportsActiveLogController ($rootScope, $http, NotificationService, ReportsActiveLogService, MessageWebhookService) {
    const vm = this

    // constants
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    }
    vm.show = false
    const HTTP_REQUEST_TIMEOUT = 408
    const HTTP_NOT_FOUND = 404
    const LABEL_SENDINGS = $rootScope.labels.sendings || 'Envios'
    const LABEL_DAY = $rootScope.labels.day || 'Dia'

    const getTags = () => {
      MessageWebhookService
        .all()
        .$promise
        .then(function (data) {
          vm.tags = data.filter((webhook) => {
            if (webhook.tag) {
              return true
            }
          }).map((webhook) => { return webhook.tag })
        }).catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorGetFilters)
        })
    }

    const dateSelected = (type, date) => {
      if (type === 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    const getTitleChart = () => {
      return $rootScope.labels.title + ' | ' + vm.filters.fromDate + ' - ' + vm.filters.toDate
    }

    const createChart = () => {
      const ctx = angular.element('#active-chart')
      vm.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: [],
          datasets: [{
            label: LABEL_SENDINGS,
            borderColor: '#37BC9B',
            backgroundColor: '#D7F5EE',
            data: [],
            borderWidth: 1,
            title: LABEL_DAY
          }]
        },
        options: {
          title: {
            display: true,
            fontSize: 15,
            text: getTitleChart()
          },
          tooltips: {
            callbacks: {
              title: function (tooltipItem, data) {
                const labelDay = data.datasets[0].title
                const configs = tooltipItem[0] || null
                if (!configs) {
                  return ''
                }
                const numberDay = configs.xLabel
                return labelDay + ': ' + numberDay
              }
            }
          },
          legend: {
            display: true,
            position: 'top'
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      })
    }

    const addData = (label, data) => {
      if (data.length === 1) {
        data.push(0)
        label.push(1)
        data.reverse()
        label.reverse()
      }

      setColorInChart()

      vm.chart.options.title.text = getTitleChart()
      vm.chart.data.labels = [...label]
      vm.chart.data.datasets.forEach((dataset) => {
        dataset.data = [...data]
      })
      vm.chart.update()
    }

    const setColorInChart = () => {
      if (vm.filters.tag || vm.filters.phone) {
        vm.chart.data.datasets.forEach((dataset) => {
          dataset.borderColor = '#DA4453'
          dataset.backgroundColor = '#FFC8CE'
        })
        return true
      }
      vm.chart.data.datasets.forEach((dataset) => {
        dataset.borderColor = '#37BC9B'
        dataset.backgroundColor = '#D7F5EE'
      })
      return true
    }

    const search = () => {
      if (validateFields()) {
        if (!vm.chart) {
          createChart()
        }
        ReportsActiveLogService
          .getData(vm.filters)
          .$promise
          .then(function (data) {
            if (data.success && data.labels.length && data.count.length) {
              vm.show = true
              addData(data.labels, data.count)
              return true
            }
            vm.show = false
            NotificationService.warningHandler(data, $rootScope.labels.noRecordsFound)
            return false
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, $rootScope.labels.errorGetInfo)
          })
      }
    }

    const download = () => {
      if (validateFields()) {
        $http.get(apiUrl + '/reports-active/download', { params: vm.filters })
          .then(function ({ data }) {
            prepareFileForDownload(data)
            return true
          }, function ({ data, status }) {
            if (status === HTTP_REQUEST_TIMEOUT) {
              NotificationService.warningHandler(data, $rootScope.labels.alertProcessMail)
              return false
            }
            if (status === HTTP_NOT_FOUND) {
              NotificationService.warningHandler(data, $rootScope.labels.noRecordsFound)
              return false
            }
            NotificationService.errorHandler('', $rootScope.labels.errorReport)
          })
      }
    }

    const validateFields = () => {
      const toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      const fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate)
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        NotificationService.warningHandler('', $rootScope.labels.dateMore30Days)
        return false
      }
      return true
    }

    const prepareFileForDownload = (data) => {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([data], { type: 'text/csv' })
      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'active-report.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    getTags()

    // functions
    vm.dateSelected = dateSelected
    vm.search = search
    vm.download = download
  }
  // eslint-disable-next-line semi
})();
